'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoreFinder = function StoreFinder(el) {
  (0, _classCallCheck3.default)(this, StoreFinder);

  var google = window.google;
  var bounds = new google.maps.LatLngBounds();
  var maplis = {
    mapTypeId: 'roadmap',
    zoom: 4,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControlOptions: {
      position: google.maps.ControlPosition.TOP_RIGHT
    },
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_TOP
    },
    styles: [{
      featureType: 'administrative',
      elementType: 'labels.text.fill',
      stylers: [{
        color: '#6195a0'
      }]
    }, {
      featureType: 'administrative.province',
      elementType: 'geometry.stroke',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [{
        lightness: '0'
      }, {
        saturation: '0'
      }, {
        color: '#f5f5f2'
      }, {
        gamma: '1'
      }]
    }, {
      featureType: 'landscape.man_made',
      elementType: 'all',
      stylers: [{
        lightness: '-3'
      }, {
        gamma: '1.00'
      }]
    }, {
      featureType: 'landscape.natural.terrain',
      elementType: 'all',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'poi',
      elementType: 'all',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'poi.park',
      elementType: 'geometry.fill',
      stylers: [{
        color: '#D0EDDD'
      }, {
        visibility: 'on'
      }]
    }, {
      featureType: 'road',
      elementType: 'all',
      stylers: [{
        saturation: -30
      }, {
        lightness: 45
      }, {
        visibility: 'simplified'
      }]
    }, {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [{
        visibility: 'simplified'
      }]
    }, {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [{
        color: '#CBD5D8'
      }, {
        visibility: 'simplified'
      }]
    }, {
      featureType: 'road.highway',
      elementType: 'labels.text',
      stylers: [{
        color: '#fff'
      }]
    }, {
      featureType: 'road.arterial',
      elementType: 'labels.text.fill',
      stylers: [{
        color: '#787878'
      }]
    }, {
      featureType: 'road.arterial',
      elementType: 'labels.icon',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'transit',
      elementType: 'all',
      stylers: [{
        visibility: 'simplified'
      }]
    }, {
      featureType: 'transit.station.airport',
      elementType: 'labels.icon',
      stylers: [{
        hue: '#0a00ff'
      }, {
        saturation: '-77'
      }, {
        gamma: '0.57'
      }, {
        lightness: '0'
      }]
    }, {
      featureType: 'transit.station.rail',
      elementType: 'labels.text.fill',
      stylers: [{
        color: '#43321e'
      }]
    }, {
      featureType: 'transit.station.rail',
      elementType: 'labels.icon',
      stylers: [{
        hue: '#ff6c00'
      }, {
        lightness: '4'
      }, {
        gamma: '0.75'
      }, {
        saturation: '-68'
      }]
    }, {
      featureType: 'water',
      elementType: 'all',
      stylers: [{
        color: '#eaf6f8'
      }, {
        visibility: 'on'
      }]
    }, {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [{
        color: '#DEE8EF'
      }]
    }, {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{
        lightness: '-49'
      }, {
        saturation: '-53'
      }, {
        gamma: '0.79'
      }]
    }]

    // Display a map on the page
  };var map = new google.maps.Map(document.getElementById('map-Canvas'), maplis);
  map.setTilt(45);

  // Get the stores & data from shopify section information
  var stores = [];

  // Loop through our array of markers & place each one on the map
  var shopsMarkers = [];
  var infowindows = [];

  function getMarkers(region, type) {
    stores = [];
    if (region === 'all' && type === 'all') {
      (0, _jquery2.default)('.stf-List_Item').each(function () {
        var $this = (0, _jquery2.default)(this);
        stores.push([$this.data('name'), $this.data('lat'), $this.data('lng'), $this.data('type'), $this.data('country')]);
      });
    } else if (region === 'all') {
      (0, _jquery2.default)('.stf-List_Item').each(function () {
        var $this = (0, _jquery2.default)(this);
        if ($this.data('type') === type) {
          stores.push([$this.data('name'), $this.data('lat'), $this.data('lng'), $this.data('type'), $this.data('country')]);
        }
      });
    } else if (type === 'all') {
      (0, _jquery2.default)('.stf-List_Item').each(function () {
        var $this = (0, _jquery2.default)(this);
        if ($this.data('country') === region) {
          stores.push([$this.data('name'), $this.data('lat'), $this.data('lng'), $this.data('type'), $this.data('country')]);
        }
      });
    } else {
      (0, _jquery2.default)('.stf-List_Item').each(function () {
        var $this = (0, _jquery2.default)(this);
        if ($this.data('country') === region && $this.data('type') === type) {
          stores.push([$this.data('name'), $this.data('lat'), $this.data('lng'), $this.data('type'), $this.data('country')]);
        }
      });
    }

    return stores;
  }

  function removeMarkers(markersArray) {
    for (var i = 0; i < markersArray.length; i++) {
      markersArray[i].setMap(null);
    }
  }

  function setMarkers(locations) {
    var i = shopsMarkers.length;
    while (i--) {
      shopsMarkers.splice(i, 1);
    }

    var _loop = function _loop(_i2) {
      ;(function () {
        var j = _i2;
        var position = new google.maps.LatLng(locations[_i2][1], locations[_i2][2]);
        var category = locations[_i2][3];
        var region = locations[_i2][4];

        var icon = {
          url: 'https://cdn.shopify.com/s/files/1/0201/1771/7092/files/pin.png?144427',
          size: new google.maps.Size(24, 33),
          scaledSize: new google.maps.Size(24, 33)
        };

        bounds.extend(position);
        shopsMarkers.push(new google.maps.Marker({
          position: position,
          map: map,
          category: category,
          title: locations[_i2][0],
          region: region,
          icon: icon
        }));

        infowindows[_i2] = new google.maps.InfoWindow({
          content: '<div class=\'map-Marker_Content\'>' + (0, _jquery2.default)('.stf-List_Item .stf-List_ItemInner:contains(\'' + locations[_i2][0] + '\')').parent().html() + '</div>'
        });

        shopsMarkers[_i2].addListener('click', function () {
          for (_i2 = 0; _i2 < locations.length; _i2++) {
            infowindows[_i2].close();
          }
          infowindows[j].open(map, shopsMarkers[j]);
        });
      })();
      _i = _i2;
    };

    for (var _i = 0; _i < locations.length; _i++) {
      _loop(_i);
    }
  }

  setMarkers(getMarkers('all', 'all'));

  /**
   * Function to filter markers by category
   */

  // Override our map zoom level once our fitBounds function runs (Make sure it only runs once)
  var boundsListener = google.maps.event.addListener(map, 'bounds_changed', function (event) {
    this.setZoom(7);
    google.maps.event.removeListener(boundsListener);
  });
  var latLng = new google.maps.LatLng(53.408371, -2.991573); // Makes a latlng
  map.panTo(latLng); // Make map global

  // map jumping and showing stores in current countries
  var CountriesGeolocations = {
    UK: '53.408371, -2.991573',
    'Hong-Kong': '22.396427, 114.109497',
    Ireland: '53.412910, -8.243890',
    China: '35.861660, 104.195396',
    Australia: '-25.274399, 133.775131',
    Gibraltar: '36.140751, -5.353585',
    US: '38.300715, -90.765714'

    /* Postcode search */
  };var inputAutocomplete = document.getElementById('inputAutocomplete');
  var autocomplete = new google.maps.places.Autocomplete(inputAutocomplete);

  var activeIcon = {
    url: 'https://cdn.shopify.com/s/files/1/0201/1771/7092/files/pin-active.png?144438',
    size: new google.maps.Size(24, 33),
    scaledSize: new google.maps.Size(24, 33)
  };

  autocomplete.bindTo('bounds', map);

  // Set the data fields to return when the user selects a place.
  autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);

  var marker = new google.maps.Marker({
    map: map,
    icon: activeIcon,
    anchorPoint: new google.maps.Point(0, -29)
  });

  autocomplete.addListener('place_changed', function () {
    marker.setVisible(false);
    var place = autocomplete.getPlace();

    // If the place has a geometry, then present it on a map.
    if (place.geometry.viewport) {
      map.fitBounds(place.geometry.viewport);
      map.setZoom(9); // Why 17? Because it looks good.
    } else {
      map.setCenter(place.geometry.location);
      map.setZoom(9); // Why 17? Because it looks good.
    }
    marker.setPosition(place.geometry.location);
    marker.setVisible(true);
  });

  var calcDistance = function calcDistance(p1, p2) {
    return (google.maps.geometry.spherical.computeDistanceBetween(p1, p2) / 1000).toFixed(2) * 0.621371;
  };

  var hideInRadius = function hideInRadius(distance, shopsMarkers) {
    for (var i = 0; i < shopsMarkers.length; i++) {
      if (marker.getPosition()) {
        var distanceBetween = calcDistance(marker.getPosition(), shopsMarkers[i].getPosition());
        if (distanceBetween > distance) {
          shopsMarkers[i].setVisible(false);
        } else {
          shopsMarkers[i].setVisible(true);
        }
      }
    }
  };

  /* Click a link in the left column to reveal infowindow on the map */
  (0, _jquery2.default)('.stf-List_ItemLink').click(function (e) {
    var name = (0, _jquery2.default)(this).data('name');
    for (var i = 0; i < shopsMarkers.length; i++) {
      if (name === shopsMarkers[i].title) {
        google.maps.event.trigger(shopsMarkers[i], 'click');
      }
    }
  });

  (0, _jquery2.default)('.stf-SelectOption-selected').click(function () {
    var $this = (0, _jquery2.default)(this);
    (0, _jquery2.default)('.stf-Select_Options').not($this.parent().find('.stf-Select_Options')).slideUp(function () {});
    $this.parent().find('.stf-Select_Options').slideToggle();
  });

  (0, _jquery2.default)('.stf-Select_Option').click(function (e) {
    var name = (0, _jquery2.default)(this).data('name');
    var value = (0, _jquery2.default)(this).data('value');
    (0, _jquery2.default)(this).parent().parent().find('.stf-SelectOption-selected').data('value', value);
    (0, _jquery2.default)(this).parent().slideUp();

    var country = (0, _jquery2.default)('.stf-SelectOption-countrySelected').data('value');
    var type = (0, _jquery2.default)('.stf-SelectOption-typeSelected').data('value');
    var distance = (0, _jquery2.default)('.stf-SelectOption-distanceSelected').data('value');
    if ((0, _jquery2.default)(this).parent().attr('id') === 'distance' && distance !== 'all') {
      if (marker.getPosition()) {
        (0, _jquery2.default)('.stf-List_Item').each(function () {
          var storeLat = (0, _jquery2.default)(this).data('lat');
          var storeLng = (0, _jquery2.default)(this).data('lng');
          var storeCord = new google.maps.LatLng(storeLat, storeLng);
          var distanceBetween = calcDistance(marker.getPosition(), storeCord);
          if (distanceBetween > distance) {
            (0, _jquery2.default)(this).attr('data-distance-show', 'false');
          } else {
            (0, _jquery2.default)(this).attr('data-distance-show', 'true');
          }
        });
      } else {
        (0, _jquery2.default)('#inputAutocomplete').focus();
        return;
      }
    }
    (0, _jquery2.default)(this).parent().parent().find('.stf-SelectOption-selected').text(name);
    (0, _jquery2.default)(this).parent().find('.stf-Select_Option').removeClass('stf-Select_Option-active');
    (0, _jquery2.default)(this).addClass('stf-Select_Option-active');

    (0, _jquery2.default)('.stf-List_Item').hide();

    var typeProperties = void 0,
        countryProperties = void 0;
    var distanceProperties = '[data-distance-show="true"]';
    type === 'all' ? typeProperties = '' : typeProperties = '[data-type="' + type + '"]';
    country === 'all' ? countryProperties = '' : countryProperties = '[data-country="' + country + '"]';
    var filterProperties = typeProperties + countryProperties + distanceProperties;
    (0, _jquery2.default)('.stf-List_Item' + filterProperties).show();
    if ((0, _jquery2.default)('.stf-List_Item').length === (0, _jquery2.default)('.stf-List_Item:hidden').length) {
      (0, _jquery2.default)('.stf-Item_BodyEmpty').removeClass('stf-Item_BodyEmpty-hidden');
    } else {
      (0, _jquery2.default)('.stf-Item_BodyEmpty').addClass('stf-Item_BodyEmpty-hidden');
    }
    if ((0, _jquery2.default)(this).parent().attr('id') === 'countries') {
      var _latLng = new google.maps.LatLng(53.408371, -2.991573); // Makes a latlng
      map.panTo(_latLng); // Make map global
      for (var key in CountriesGeolocations) {
        if (key === country) {
          var val = CountriesGeolocations[key];
          val = val.split(',');
          var _latLng2 = new google.maps.LatLng(val[0], val[1]); // Makes a latlng
          map.panTo(_latLng2); // Make map global
          break;
        }
      }
      map.setZoom(7);
    }
    removeMarkers(shopsMarkers);

    setMarkers(getMarkers(country, type));
    hideInRadius(distance, shopsMarkers);
  });
};

exports.default = StoreFinder;